import React, { useEffect, useState } from "react";
import fetchData from "../../../api/fetchApi";
import Table from "../../common/Table";
import PageHeader from "../../common/PageHeader";
import { useNavigate } from "react-router-dom";
import { Users } from "lucide-react";

function ConfirmDeleteModal({ open, onClose, onConfirm, name }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
      <div className="bg-white rounded-xl shadow-lg p-6 w-full max-w-sm">
        <h3 className="font-bold text-lg mb-4">تأكيد الحذف</h3>
        <div className="mb-4">هل أنت متأكد أنك تريد حذف الموزع <b>{name}</b>؟ لا يمكن التراجع عن هذا الإجراء.</div>
        <div className="flex gap-2 mt-2 justify-end">
          <button className="bg-red-600 text-white px-4 py-2 rounded" onClick={onConfirm}>حذف</button>
          <button className="bg-gray-200 px-4 py-2 rounded" onClick={onClose}>إلغاء</button>
        </div>
      </div>
    </div>
  );
}

export default function ResellersPage() {
  const [resellers, setResellers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalResellers, setTotalResellers] = useState(0);
  const [deleteModal, setDeleteModal] = useState({ open: false, reseller: null });
  const [deleteError, setDeleteError] = useState(null);
  const navigate = useNavigate();

  const fetchResellers = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await fetchData(`finance/resellers?page=${currentPage}&per_page=${perPage}`);
      setResellers(data.data || []);
      setTotalResellers(data.meta?.total || 0);
      setCurrentPage(data.meta?.current_page || 1);
      setTotalPages(data.meta?.last_page || 1);
    } catch (err) {
      setError(err.message || "حدث خطأ أثناء جلب البيانات");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchResellers();
    // eslint-disable-next-line
  }, [currentPage, perPage]);

  const handleDelete = async () => {
    if (!deleteModal.reseller) return;
    setDeleteError(null);
    try {
      await fetchData(`finance/resellers/${deleteModal.reseller.id}`, "DELETE");
      setDeleteModal({ open: false, reseller: null });
      fetchResellers();
    } catch (err) {
      setDeleteError(err.message || "حدث خطأ أثناء الحذف");
    }
  };

  const columns = [
    { header: "المعرف", accessor: "id" },
    { header: "الاسم", accessor: "name" },
    { header: "البريد الإلكتروني", accessor: "email" },
    { header: "الهاتف", accessor: "phone" },
    { header: "العنوان", accessor: "address" },
    { header: "نشط؟", accessor: "is_active", render: row => row.is_active ? "نعم" : "لا" },
    { header: "موزع؟", accessor: "is_reseller", render: row => row.is_reseller ? "نعم" : "لا" },
    { header: "نسبة العمولة", accessor: "commissions_rate" },
    { header: "تاريخ الإنشاء", accessor: "created_at" },
  ];

  return (
    <div className="min-h-screen p-4 md:p-6 bg-white" dir="rtl">
        <PageHeader title="إجمالي الموزعين" total={
          totalResellers
        } stats={[]}>
            <button className="px-3 py-2 rounded-lg border border-gray-200 bg-white text-sm text-[#1D2035] flex items-center gap-2">
              <span className="inline-block rotate-180">↕</span>
              من الاحدث إلى الأقدم
            </button>
            
            <button
              className="bg-blue-600 text-white px-4 py-2 rounded-lg flex items-center gap-2"
            onClick={() => navigate("/finance/resellers/new")}>إضافة موزع جديد</button>
   
          </PageHeader>
      <ConfirmDeleteModal
        open={deleteModal.open}
        name={deleteModal.reseller?.name}
        onClose={() => setDeleteModal({ open: false, reseller: null })}
        onConfirm={handleDelete}
      />
      <div className="mt-5">
        <Table
          columns={columns}
          rows={resellers}
          act={[
            {
              label: <span className="text-blue-600">عرض</span>,
              onClick: (row) => navigate(`/finance/resellers/${row.id}`)
            },
           
            {
              label: <span className="text-red-600">حذف</span>,
              onClick: (row) => setDeleteModal({ open: true, reseller: row })
            }
          ]}
          pagination={{
            title: "الموزعون",
            label: `الصفحة ${currentPage} من ${totalPages}`,
            pages: Array.from({ length: totalPages }, (_, i) => i + 1),
            current: currentPage,
            last: totalPages,
            onPageChange: setCurrentPage,
            perPage: perPage,
            onPerPageChange: setPerPage,
          }}
        />
        {loading && <div className="text-center mt-4">جاري التحميل...</div>}
        {error && <div className="text-red-600 text-center mt-4">{error}</div>}
        {deleteError && <div className="text-red-600 text-center mt-4">{deleteError}</div>}
      </div>
     
    </div>
  );
}
